import { produce } from "solid-js/store";
import {
  type SetStreamingStore,
  type StreamingChatId,
  type StreamingMessageId,
  type StreamingMessage,
  type StreamingBlockId,
  type StreamingOperationId,
  StreamingMessageStatus,
} from "../streamingTypes";
import type { ChatMessages } from "@storytell/cp-client";
import { richTextToProseMirror } from "@storytell/rich-text";

export const processMessage = (setStore: SetStreamingStore, message: ChatMessages.Message) => {
  console.log("zzz processMessage", message);
};

/**
 * MESSAGE_START is the first event we receive for a message.
 */
export const processMessageStart = (
  setStore: SetStreamingStore,
  message: ChatMessages.Message,
  onChatIdCaptured?: (chatId: StreamingChatId) => void,
) => {
  if (message.data.case !== "messageStartData") {
    console.error(new Error(`Expected messageStartData, got ${message.data.case}`));
    return;
  }
  const {
    id,
    index,
    blockId,
    operationId,
    role,
    data: { value: data },
  } = message;
  const chatId = data.chatId as StreamingChatId;

  try {
    if (onChatIdCaptured) {
      onChatIdCaptured(chatId);
    }
  } catch (error) {
    console.error("Error on the callback for capturing chat ID", error);
  }

  const messageId = id as StreamingMessageId;

  const streamingMessage: StreamingMessage = {
    id: messageId,
    index,
    role,
    chatId,
    operations: [],
    feature: data.feature,
    status: StreamingMessageStatus.GENERATING,
    aggregateMetrics: {
      ingressTokens: 0,
      egressTokens: 0,
      ingressBytes: 0,
      egressBytes: 0,
      totalCredits: 0,
      ingressCredits: 0,
      egressCredits: 0,
      lastUpdated: new Date(0),
    },
    prompt: {
      messageId,
      text: data.promptText,
      richText: data.promptRichText ? richTextToProseMirror(data.promptRichText) : undefined,
      blockId: blockId as StreamingBlockId,
      operationId: operationId as StreamingOperationId,
    },
  };

  setStore(
    produce((store) => {
      // Insert the message at the correct position
      if (!store.chats[chatId]) {
        store.chats[chatId] = {
          id: chatId,
          messages: [],
          aggregateMetrics: {
            ingressTokens: 0,
            egressTokens: 0,
            ingressBytes: 0,
            egressBytes: 0,
            totalCredits: 0,
            ingressCredits: 0,
            egressCredits: 0,
            lastUpdated: new Date(0),
          },
        };
      }

      store.messages[messageId] = streamingMessage;

      // Order the messages by oldest first
      if (store.chats[chatId] && !store.chats[chatId].messages.includes(messageId)) {
        const newMessages = [...store.chats[chatId].messages, messageId];
        store.chats[chatId].messages = newMessages.sort(
          (a, b) => (store.messages[a]?.index || 0) - (store.messages[b]?.index || 0),
        );
      }
    }),
  );
};

export const processMessageStop = (setStore: SetStreamingStore, message: ChatMessages.Message) => {
  const { id } = message;
  const messageId = id as StreamingMessageId;

  setStore(
    produce((store) => {
      const message = store.messages[messageId];
      // TODO: @andi streaming - should we throw here?
      // if (!message) {
      //   throw new Error(`Message not found for stop: ${messageId}`);
      // }
      if (message) {
        message.status = StreamingMessageStatus.COMPLETED;
      }
    }),
  );
};
